import React, {useState} from 'react'

export default function TextForm(props) {

    const handleUpClick = ()=>{
        // console.log("uppercase was clicked " +text);
        let newText = text.toUpperCase();
        // setText("You've clicked on Convert to Uppercase");
        setText(newText)
        props.showAlert("Converted to Uppercase","success")
    }
    
    const handleLowClick = ()=>{
        // console.log("lowercase was clicked " +text);
        let newText = text.toLowerCase();
        // setText("You've clicked on Convert to lowercase");
        setText(newText)
        props.showAlert("Converted to Lowercase","success")
    }
    
    const handleOnChange = (event)=>{
        // console.log("Change");
        setText(event.target.value);
    }

    const handleReverseString = (event)=>{
        let splitText = text.split("");
        let ReverseText = splitText.reverse();
        let joinText = ReverseText.join("");
        setText(joinText);
        props.showAlert("Strings Reversed","success")
    }
    
    const handleCopy = (event)=>{
        navigator.clipboard.writeText(text);
        props.showAlert("Copied To The Clipboard","success")
    }

    const handleExtraSpaces = ()=>{
        let newText = text.split(/[ ]+/);
        setText(newText.join(" "))
        props.showAlert("Removed Extra Spaces","success")
    }



    const [text, setText] = useState('Enter Text Here');
    return (
        <>
            <div className="container px-5" style={{color: props.mode==="light"?"black":"white",backgroundColor: props.mode==="light"?"white":"rgb(33 37 41)"}}>
                <div>
                    <h2>{props.heading}</h2>
                    <textarea className="form-control" style={{color: props.mode==="light"?"black":"white",backgroundColor: props.mode==="light"?"white":"rgb(33 37 41)"}} value={text} onChange={handleOnChange} id="myBox" rows="4"></textarea>
                </div>
                <button disabled={text.length === 0} className="btn btn-primary my-3 mx-2" onClick={handleUpClick}>Convert to Uppercase</button>
                <button disabled={text.length === 0} className="btn btn-primary my-3 mx-2" onClick={handleLowClick}>Convert to lowercase</button>
                <button disabled={text.length === 0} className="btn btn-primary my-3 mx-2" onClick={handleReverseString}>Reverse the text</button>
                <button disabled={text.length === 0} className="btn btn-primary my-3 mx-2" onClick={handleCopy}>Copy text</button>
                <button disabled={text.length === 0} className="btn btn-primary my-3 mx-2" onClick={handleExtraSpaces}>Remove Extra Spaces</button>
            
            </div>
            <div className="container my-2 px-5" style={{color: props.mode==="light"?"black":"white",backgroundColor: props.mode==="light"?"white":"rgb(33 37 41)"}}>
                <h2>Your Text Summary</h2>
                <p>{text.split(/\s+/).filter((element)=>{return element.length!==0}).length} words & {text.length} characters</p>
                <p>{0.008 * text.split(" ").filter((element)=>{return element.length!==0}).length} minute read</p>
                <h3>Preview</h3>
                <p>{text.length>0?text:"Nothing to preview"}</p>
            </div>
        </>
    )
}
